import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "pt-1 text-xs rounded-full bg-gray-300 font-normal h-6 w-6 text-center items-center text-gray-700"
}

import { getInitials } from "@/shared/utils/helpers"

interface Props {
    image?: string
    fullName?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfilePicture',
  props: {
    image: {},
    fullName: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_ctx.image)
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _ctx.image,
        class: "h-6 w-6 rounded-full object-cover"
      }, null, 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.fullName ? _unref(getInitials)(_ctx.fullName) : _ctx.fullName.charAt(0).toUpperCase()), 1))
}
}

})